import { } from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import * as actionTypes from '../constants/ring-central';

import { updateObject } from '../../../../shared/utils/utility';

import { AppAction } from '../../../../store';

import { RingCentralAccount } from '../../models';

export interface RingCentralState {
  ringCentralAccountSettings: RingCentralAccount | null;
  ringCentralAccountSettingsError: any | null;
  ringCentralAccountSettingsLoading: boolean;

  saveRingCentralAccountSettings: boolean | null;
  saveRingCentralAccountSettingsError: any | null;
  saveRingCentralAccountSettingsLoading: boolean;

  removeRingCentralAccount: boolean | null;
  removeRingCentralAccountError: any | null;
  removeRingCentralAccountLoading: boolean;

  allRingCentralPhones: Array<string> | null;
  allRingCentralPhonesError: any | null;
  allRingCentralPhonesLoading: boolean;
}

const initialState: RingCentralState = {
  ringCentralAccountSettings: null,
  ringCentralAccountSettingsError: null,
  ringCentralAccountSettingsLoading: false,

  saveRingCentralAccountSettings: null,
  saveRingCentralAccountSettingsError: null,
  saveRingCentralAccountSettingsLoading: false,

  removeRingCentralAccount: null,
  removeRingCentralAccountError: null,
  removeRingCentralAccountLoading: false,

  allRingCentralPhones: null,
  allRingCentralPhonesError: null,
  allRingCentralPhonesLoading: false,
};

const getRingCentralAccountSettingsStart = (state: RingCentralState, action: AppAction<RingCentralAccount>) => {
  return updateObject(state, {
    ringCentralAccountSettings: null,
    ringCentralAccountSettingsError: null,
    ringCentralAccountSettingsLoading: true,
  });
};

const getRingCentralAccountSettingsSuccess = (state: RingCentralState, action: AppAction<RingCentralAccount>) => {
  return updateObject(state, {
    ringCentralAccountSettings: action.data,
    ringCentralAccountSettingsError: null,
    ringCentralAccountSettingsLoading: false,
  });
};

const getRingCentralAccountSettingsFail = (state: RingCentralState, action: AppAction<RingCentralAccount>) => {
  return updateObject(state, {
    ringCentralAccountSettings: null,
    ringCentralAccountSettingsError: action.error,
    ringCentralAccountSettingsLoading: false,
  });
};

const saveRingCentralAccountSettingsStart = (state: RingCentralState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveRingCentralAccountSettingsError: null,
    saveRingCentralAccountSettingsLoading: true,
  });
};

const saveRingCentralAccountSettingsSuccess = (state: RingCentralState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveRingCentralAccountSettings: action.data,
    saveRingCentralAccountSettingsError: null,
    saveRingCentralAccountSettingsLoading: false,
  });
};

const saveRingCentralAccountSettingsFail = (state: RingCentralState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveRingCentralAccountSettings: null,
    saveRingCentralAccountSettingsError: action.error,
    saveRingCentralAccountSettingsLoading: false,
  });
};

const removeRingCentralAccountStart = (state: RingCentralState, action: AppAction<boolean>) => {
  return updateObject(state, {
    removeRingCentralAccountError: null,
    removeRingCentralAccountLoading: true,
  });
};

const removeRingCentralAccountSuccess = (state: RingCentralState, action: AppAction<boolean>) => {
  return updateObject(state, {
    removeRingCentralAccount: action.data,
    removeRingCentralAccountError: null,
    removeRingCentralAccountLoading: false,
  });
};

const removeRingCentralAccountFail = (state: RingCentralState, action: AppAction<boolean>) => {
  return updateObject(state, {
    removeRingCentralAccount: null,
    removeRingCentralAccountError: action.error,
    removeRingCentralAccountLoading: false,
  });
};

const getAllRingCentralPhonesStart = (state: RingCentralState, action: AppAction<Array<string>>) => {
  return updateObject(state, {
    allRingCentralPhones: null,
    allRingCentralPhonesError: null,
    allRingCentralPhonesLoading: true,
  });
};

const getAllRingCentralPhonesSuccess = (state: RingCentralState, action: AppAction<Array<string>>) => {
  return updateObject(state, {
    allRingCentralPhones: action.data,
    allRingCentralPhonesError: null,
    allRingCentralPhonesLoading: false,
  });
};

const getAllRingCentralPhonesFail = (state: RingCentralState, action: AppAction<Array<string>>) => {
  return updateObject(state, {
    allRingCentralPhones: null,
    allRingCentralPhonesError: action.error,
    allRingCentralPhonesLoading: false,
  });
};

const setAllRingCentralPhones = (state: RingCentralState, action: AppAction<Array<string>>) => {
  return updateObject(state, {
    allRingCentralPhones: action.data,
    allRingCentralPhonesError: null,
    allRingCentralPhonesLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.RING_CENTRAL_GET_RING_CENTRAL_SETTINGS_START:
      return getRingCentralAccountSettingsStart(state, action as AppAction<RingCentralAccount>);
    case actionTypes.RING_CENTRAL_GET_RING_CENTRAL_SETTINGS_SUCCESS:
      return getRingCentralAccountSettingsSuccess(state, action as AppAction<RingCentralAccount>);
    case actionTypes.RING_CENTRAL_GET_RING_CENTRAL_SETTINGS_FAIL:
      return getRingCentralAccountSettingsFail(state, action as AppAction<RingCentralAccount>);

    case actionTypes.RING_CENTRAL_SAVE_RING_CENTRAL_ACCOUNT_SETTINGS_START:
      return saveRingCentralAccountSettingsStart(state, action as AppAction<boolean>);
    case actionTypes.RING_CENTRAL_SAVE_RING_CENTRAL_ACCOUNT_SETTINGS_SUCCESS:
      return saveRingCentralAccountSettingsSuccess(state, action as AppAction<boolean>);
    case actionTypes.RING_CENTRAL_SAVE_RING_CENTRAL_ACCOUNT_SETTINGS_FAIL:
      return saveRingCentralAccountSettingsFail(state, action as AppAction<boolean>);

    case actionTypes.RING_CENTRAL_REMOVE_RING_CENTRAL_ACCOUNT_START:
      return removeRingCentralAccountStart(state, action as AppAction<boolean>);
    case actionTypes.RING_CENTRAL_REMOVE_RING_CENTRAL_ACCOUNT_SUCCESS:
      return removeRingCentralAccountSuccess(state, action as AppAction<boolean>);
    case actionTypes.RING_CENTRAL_REMOVE_RING_CENTRAL_ACCOUNT_FAIL:
      return removeRingCentralAccountFail(state, action as AppAction<boolean>);

    case actionTypes.RING_CENTRAL_GET_ALL_RING_CENTRAL_PHONES_START:
      return getAllRingCentralPhonesStart(state, action as AppAction<Array<string>>);
    case actionTypes.RING_CENTRAL_GET_ALL_RING_CENTRAL_PHONES_SUCCESS:
      return getAllRingCentralPhonesSuccess(state, action as AppAction<Array<string>> );
    case actionTypes.RING_CENTRAL_GET_ALL_RING_CENTRAL_PHONES_FAIL:
      return getAllRingCentralPhonesFail(state, action as AppAction<Array<string>>);
    case actionTypes.RING_CENTRAL_SET_ALL_RING_CENTRAL_PHONES:
      return setAllRingCentralPhones(state, action as AppAction<Array<string>>);

    default:
      return state;
  }
};

export default reducer;
